"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimilarProductsService = void 0;
class GetSimilarProductsError extends Error {
    constructor(message) {
        super(message);
        this.name = 'GetSimilarProductsError';
    }
}
class SimilarProductsService {
    constructor(tdcClient) {
        this.tdcClient = tdcClient;
    }
    getBySkus(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { skus, catalogSlug, businessUnit, abortSignal } = params;
            const searchParams = skus.reduce((params, sku) => {
                params.append('skus', sku);
                return params;
            }, new URLSearchParams({
                businessUnit,
                catalogSlug,
            }));
            try {
                const { data: response } = yield this.tdcClient.get('/product/gb-stock/similar-products', {
                    params: searchParams,
                    signal: abortSignal,
                });
                return response.data;
            }
            catch (error) {
                window.NREUM.noticeError(new GetSimilarProductsError('Failed to get similar products.'), {
                    origin: 'MLD/produtos-similares',
                    brand: process.env.REACT_APP_CURRENT_BRAND,
                    params: {
                        skus,
                        catalogSlug,
                        businessUnit,
                    },
                });
            }
        });
    }
}
exports.SimilarProductsService = SimilarProductsService;
